import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, switchMap, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // No agregar token a peticiones de login, refresh o logout
  const isAuthRequest = req.url.includes('/auth/login') || 
                       req.url.includes('/auth/refresh') ||
                       req.url.includes('/auth/logout');

  // Verificar si es una petición a /admin
  const isAdminRequest = req.url.includes('/admin');

  const token = authService.getAccessToken();

  // Verificar si el token expiró ANTES de enviar la petición
  if (token && !isAuthRequest && !authService.hasValidToken()) {
    console.log('Token expirado detectado proactivamente, refrescando...');
    return authService.refreshToken().pipe(
      switchMap(() => {
        const newToken = authService.getAccessToken();
        const authReq = req.clone({
          headers: req.headers.set('authorization', isAdminRequest ? newToken! : `${newToken}`)
        });
        return next(authReq);
      }),
      catchError((refreshError) => {
        console.error('Error al refrescar token proactivamente:', refreshError);
        authService.clearTokens();
        router.navigate(['/admin/login']);
        return throwError(() => refreshError);
      })
    );
  }

  // Token válido o no requiere autenticación
  let authReq = req;
  if (token && !isAuthRequest && isAdminRequest) {
    authReq = req.clone({
      headers: req.headers.set('authorization', token)
    });
  }

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      // Plan B: Si aún así llega un 401, intentar refresh
      if (error.status === 401 && !isAuthRequest) {
        console.log('Recibido 401, intentando refresh como plan B...');
        return authService.refreshToken().pipe(
          switchMap(() => {
            // Reintentar la petición original con el nuevo token
            const newToken = authService.getAccessToken();
            const retryReq = req.clone({
              headers: req.headers.set('authorization', isAdminRequest ? newToken! : `${newToken}`)
            });
            return next(retryReq);
          }),
          catchError((refreshError) => {
            // Si el refresh falla, limpiar tokens y redirigir al login
            console.error('Error al refrescar token después de 401:', refreshError);
            authService.clearTokens();
            router.navigate(['/admin/login']);
            return throwError(() => refreshError);
          })
        );
      }

      return throwError(() => error);
    })
  );
};
